import type { InputProps } from '../input-props'

export function CalculatedDisplay({ value }: InputProps) {
  return (
    <div className="bg-muted/50 border border-border rounded-md px-3 py-2 text-sm text-muted-foreground font-mono">
      {value !== undefined && value !== null && value !== '' ? String(value) : '—'}
      <span className="text-xs ms-2 text-muted-foreground/60">(محاسباتی)</span>
    </div>
  )
}
